import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MarketplaceBasketCustomFieldModel, MarketplaceCustomFieldModel } from '@fgb/core';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'fgbcl-marketplace-custom-fields',
  templateUrl: './marketplace-custom-fields.component.html',
  styleUrls: ['./marketplace-custom-fields.component.scss'],
})
export class MarketplaceCustomFieldsComponent implements OnInit {
  @Input() itemCustomFields: MarketplaceCustomFieldModel[];
  @Input() hasSumbittedForm: boolean;
  @Output() customFieldsChange = new EventEmitter<MarketplaceBasketCustomFieldModel[] | undefined>();

  customFieldsForm: UntypedFormGroup;
  dynamicFormCustomFields: MarketplaceCustomFieldModel[] = [];

  private _destroyed$ = new Subject<void>();

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit() {
    this.customFieldsForm = this.formBuilder.group({
      customFieldsGroup: this.formBuilder.array([]),
    });

    this._setCustomFields();

    this.customFieldsForm.valueChanges
      .pipe(
        takeUntil(this._destroyed$),
        tap(() => this.emitCustomFieldsValues())
      )
      .subscribe();
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  emitCustomFieldsValues() {
    let customFields: MarketplaceBasketCustomFieldModel[] = [];
    for (let index = 0; index < this.dynamicFormCustomFields.length; index++) {
      const control = this.customFieldsForm.get(index.toString());
      if (control) {
        let newCustomField = {
          customFieldId: this.dynamicFormCustomFields[index].CustomFieldId,
          customFieldName: this.dynamicFormCustomFields[index].DisplayName,
          customFieldValue: control.value,
        } as MarketplaceBasketCustomFieldModel;

        customFields.push(newCustomField);
      }
    }

    if (!this.customFieldsForm.valid) {
      this.customFieldsChange.emit(undefined);
    } else {
      this.customFieldsChange.emit(customFields);
    }
  }

  isRequiredField(fieldIndex: number) {
    const formField = this.customFieldsForm.controls[fieldIndex];
    if (!formField.validator) {
      return false;
    }

    const validator = formField.validator({} as AbstractControl);
    return validator && validator.required;
  }

  private _setCustomFields() {
    if (this.itemCustomFields) {
      for (let index = 0; index < this.itemCustomFields.length; index++) {
        let currentCustomField = this.itemCustomFields[index];
        this.dynamicFormCustomFields.push(currentCustomField);

        let validators = [];

        if (currentCustomField.FieldType == 2) {
          if (currentCustomField.IsRequired) {
            validators.push(Validators.requiredTrue);
          }
        } else {
          if (currentCustomField.IsRequired) {
            validators.push(Validators.required);
          }

          if (currentCustomField.CharacterLimit > 0) {
            validators.push(Validators.maxLength(currentCustomField.CharacterLimit));
          }
          if (currentCustomField.ValidationRegEx != '') {
            validators.push(Validators.pattern(currentCustomField.ValidationRegEx));
          }
        }

        this.customFieldsForm.addControl(index.toString(), new UntypedFormControl('', validators));
      }
    }
    this.emitCustomFieldsValues();
  }
}
